import { motion } from "framer-motion";
import * as LucideIcons from "lucide-react";
import { Check } from "lucide-react";
import { SOLUTIONS } from "@/lib/constants";

export default function Solutions() {
  return (
    <section className="bg-white py-24" data-testid="solutions-section">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">Solutions</div>
          <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-[#0B1F3A] tracking-tight text-balance">
            Nos solutions pour <span className="text-[#00B8D9]">accélérer votre croissance</span>
          </h2>
          <p className="mt-4 text-[#4B5563] text-lg">
            Quatre piliers complémentaires qui transforment votre entreprise en machine de croissance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {SOLUTIONS.map((s, i) => {
            const Icon = LucideIcons[s.icon] || LucideIcons.Sparkles;
            const dark = i === 1 || i === 2;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`solution-card-${i}`}
                className={`group p-8 rounded-2xl border transition-all duration-300 ${
                  dark
                    ? "bg-[#0B1F3A] text-white border-[#0B1F3A] hover:border-[#00B8D9]"
                    : "bg-[#F5F7FA] text-[#0B1F3A] border-gray-200 hover:border-[#00B8D9] hover:bg-white"
                } hover:-translate-y-1 hover:shadow-xl`}
              >
                <div className="flex items-start justify-between mb-5">
                  <div className={`h-12 w-12 rounded-lg flex items-center justify-center ${dark ? "bg-[#00B8D9]" : "bg-[#00B8D9]/10 group-hover:bg-[#00B8D9]"} transition-colors`}>
                    <Icon className={`h-6 w-6 ${dark ? "text-white" : "text-[#00B8D9] group-hover:text-white"} transition-colors`} />
                  </div>
                  <div className={`text-5xl font-heading font-black opacity-10 ${dark ? "text-white" : "text-[#0B1F3A]"}`}>0{i + 1}</div>
                </div>
                <h3 className="font-heading font-bold text-2xl mb-4">{s.title}</h3>
                <ul className="space-y-2">
                  {s.items.map((it) => (
                    <li key={it} className={`flex items-center gap-2 text-sm ${dark ? "text-gray-200" : "text-[#4B5563]"}`}>
                      <Check className={`h-4 w-4 ${dark ? "text-[#00B8D9]" : "text-[#00B8D9]"}`} />
                      {it}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
